export default {
	"en":
	{ "backToDeposits": "Back to Deposit Methods",
	  "backToWithdrawals": "Back to Withdraw Methods"
	}
}



// WEBPACK FOOTER //
// ./src/local/translate.js